/* eslint-disable */
import React, { useState, useRef } from 'react';

function ResultScreen({ score, time, level, AudioUrl, onPlayAgain, wordList }) {
  const [analysisResult, setAnalysisResult] = useState(null);
  const [isLoading, setIsLoading] = useState(true); // Começamos com loading true
  const [error, setError] = useState(null);
  const [analyzing, setAnalyzing] = useState(false);
  const [hasSubmitted, setHasSubmitted] = useState(false);
  const isInitialRender = useRef(true);

  const convertBlobUrlToFile = async (blobUrl) => {
    try {
      const response = await fetch(blobUrl);
      const blob = await response.blob();
      return blob;
    } catch (error) {
      console.error("Erro ao converter blob URL:", error);
      throw error;
    }
  };

  const submitGameResults = async () => {
    if (hasSubmitted) return;
    
    try {
      setIsLoading(true);
      setHasSubmitted(true);

      // Se não houver AudioUrl, enviar apenas os dados básicos do jogo
      if (!AudioUrl) {
        const basicGameData = {
          score,
          time,
          level,
          wordList: Array.isArray(wordList)
            ? wordList.map(word => ({
                verbete: typeof word === 'string' ? word : word.verbete,
                level: level
              }))
            : []
        };

        // Define um resultado básico sem análise de áudio
        setAnalysisResult({
          gameStats: basicGameData,
          analysis: null,
          wordList: basicGameData.wordList
        });
        setIsLoading(false);
        return;
      }

      // Processo normal com áudio
      let audioBlob = null;
      if (AudioUrl.startsWith('blob:')) {
        audioBlob = await convertBlobUrlToFile(AudioUrl);
      }

      const formData = new FormData();

      if (audioBlob) {
        formData.append('audio', audioBlob, 'audio.wav');
      }

      formData.append('score', score.toString());
      formData.append('time', time.toString());
      formData.append('level', level);

      const formattedWordList = Array.isArray(wordList)
        ? wordList.map(word => ({
          verbete: typeof word === 'string' ? word : word.verbete,
          level: level
        }))
        : [];

      formData.append('wordList', JSON.stringify(formattedWordList));

      console.log("Enviando dados para API:", {
        score,
        time,
        level,
        wordList: formattedWordList
      });

      //const response = await fetch('http://localhost:8080/api/v1/auth/analyze-game', {
      const response = await fetch('https://api.juntaletras.com.br/api/v1/auth/analyze-game', {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: formData
      });

      if (!response.ok) {
        const errorData = await response.text();
        console.error("Erro da API:", errorData);
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log("Resposta da API:", data);
      setAnalysisResult(data);
    } catch (error) {
      console.error("Erro ao enviar resultados:", error);
      setError(error.message);
      setHasSubmitted(false);
    } finally {
      setIsLoading(false);
      setAnalyzing(false);
    }
  };

  // Chamada imediata na primeira renderização
  if (isInitialRender.current) {
    isInitialRender.current = false;
    submitGameResults();
  }
  
  const formatTime = (timeInSeconds) => {
    const minutes = Math.floor(timeInSeconds / 60);
    const seconds = timeInSeconds % 60;
    return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
  };

  const getMessage = () => {
    if (score >= 90) return "Excelente!";
    if (score >= 70) return "Muito bom!";
    if (score >= 50) return "Bom trabalho!";
    return "Continue praticando!";
  };

  return (
    <div>
      <div className="bgc"></div>
      <div className="bgc bg2"></div>
      <div className="bgc bg3"></div>
      <div className="result-screen">
        <div className="result-card">
          {isLoading ? (
            <div className="loading">Analisando resultados...</div>
          ) : error ? (
            <div className="error">
              <p>Erro ao processar resultados: {error}</p>
              <button className="retry-btn" onClick={() => window.location.reload()}>
                Tentar Novamente
              </button>
            </div>
          ) : (
            <>
              <h1>{getMessage()}</h1>

              <div className="result-stats">
                <div className="stat">
                  <span className="stat-label">Pontuação:</span>
                  <span className="stat-value">{score} pontos</span>
                </div>

                <div className="stat">
                  <span className="stat-label">Tempo:</span>
                  <span className="stat-value">{formatTime(time)}</span>
                </div>

                <div className="stat">
                  <span className="stat-label">Nível:</span>
                  <span className="stat-value">{level.charAt(0).toUpperCase() + level.slice(1)}</span>
                </div>

                <div className="word-list">
                  <h3>Palavras do jogo:</h3>
                  <ul>
                    {wordList.map((word, index) => (
                      <li key={index}>{word.verbete}</li>
                    ))}
                  </ul>
                </div>

                {AudioUrl && (
                  <div className="audio-player">
                    <p className="audio-label">Áudio</p>
                    <audio
                      controls
                      src={AudioUrl}
                      onError={(e) => console.error("Erro ao carregar áudio:", e)}
                    />
                  </div>
                )}

                {analysisResult?.analysis && (
                  <div className="analysis-result">
                    <h3>Análise do Áudio:</h3>
                    <p>Precisão: {analysisResult.analysis.accuracy}%</p>
                    <p>Palavras corretas: {analysisResult.analysis.correctWords}/{analysisResult.analysis.totalWords}</p>

                    <div className="word-comparisons">
                      {analysisResult.analysis.wordComparisons?.map((comparison, index) => (
                        <div key={index} className={`word-comparison ${comparison.recognized ? 'correct' : 'incorrect'}`}>
                          <span>Original: {comparison.original}</span>
                          {comparison.recognized && <span>Reconhecido: {comparison.found}</span>}
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>

              <div className="result-actions">
                {AudioUrl && !analysisResult?.analysis && (
                  <button
                    disabled={analyzing}
                  >
                    {analyzing ? 'Analisando...' : 'Analisar Áudio'}
                  </button>
                )}
                <button className="play-again-btn" onClick={onPlayAgain}>
                  Jogar Novamente
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default ResultScreen;
